/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-22, 14:15:11
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-05, 13:08:17
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
import {
  LOGIN_REQUEST, SET_SMS_CODE, LOGIN_SUCCESS, LOGOUT_SUCCESS, LOGIN_FAIL, TOGGLE_LOGIN_LOADING,
  UNDO_LOGIN_STATE, SET_SUBSCRIBER_MAIN_DATA, SET_SUBSCRIBER_SETTINGS, SET_SUBSCRIBER_ACL_FOR_GROUPS_OF_NUMBERS,
  CONFIRM_CHANGE_PASSWORD,
} from './mutation-types';

export default {
  [LOGIN_REQUEST](state, payload) {
    const _state = state;
    _state.authType = payload.authType;
    _state.loginCredentialsIncorrect = false;
    _state.subscriber.number = payload.subscriberNumber || state.subscriber.number;
    _state.loginLoadingActive = !state.loginLoadingActive;
  },
  [SET_SMS_CODE](state, payload) {
    const _state = state;
    _state.subscriber.code = payload.SMSCode;
  },
  [LOGIN_SUCCESS](state) {
    const _state = state;
    _state.isAuthenticated = true;
  },
  [LOGOUT_SUCCESS](state) {
    const _state = state;
    _state.authType = 'initial';
    _state.isAuthenticated = false;
    _state.loginCredentialsIncorrect = false;
    _state.subscriber = {
      number: null,
      code: null,
      type: null,
      id: null,
      accountBalance: null,
      complains_categories: null,
    };
  },
  [LOGIN_FAIL](state, payload) {
    const _state = state;
    _state.loginCredentialsIncorrect = true;
    _state.loginErrorReason = payload.errorMessage;
  },
  [TOGGLE_LOGIN_LOADING](state) {
    const _state = state;
    _state.loginLoadingActive = !state.loginLoadingActive;
  },
  [UNDO_LOGIN_STATE](state, payload) {
    const _state = state;
    _state.authType = payload.previousState;
    _state.loginCredentialsIncorrect = false;
  },
  [SET_SUBSCRIBER_MAIN_DATA](state, payload) {
    const _state = state;
    _state.subscriber = payload;
  },
  [SET_SUBSCRIBER_SETTINGS](state, payload) {
    const _state = state;
    _state.settings.complainsCategories = payload.complains_categories;
  },
  [SET_SUBSCRIBER_ACL_FOR_GROUPS_OF_NUMBERS](state, payload) {
    const _state = state;
    _state.acl.isMainNumber = payload.is_main_number || true;
    _state.acl.privileges = payload.privileges || {};
  },
  [CONFIRM_CHANGE_PASSWORD](state, payload) {
    const _state = state;
    _state.authType = payload.authType;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/Subscriber/mutations.js